/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * AssignmentsOverview
 *
 * @file AssignmentsOverview.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';

import StudentDashboardStyles from './styles/StudentDashboardStyles';

import StudentList from './components/StudentList';
import StudentDetails from './components/StudentDetails';

const StudentDashboard = ({
  students = [],
  selectedStudent,
  onSelect,
  onDifficultTopicClick
}) => {
  const classes = StudentDashboardStyles();

  return (
    <div className={classes.container}>
      <div className={classes.col1}>
        <StudentList
          students={students}
          selectedStudent={selectedStudent}
          onSelect={onSelect}
        />
      </div>
      <div className={classes.col2}>
        <StudentDetails
          {...selectedStudent}
          onDifficultTopicClick={onDifficultTopicClick}
        />
      </div>
    </div>
  );
};

StudentDashboard.propTypes = {
  students: PropTypes.array,
  selectedStudent: PropTypes.object,
  onSelect: PropTypes.func,
  onDifficultTopicClick: PropTypes.func
};

StudentDashboard.defaultProps = {
  students: [],
  selectedStudent: {},
  onSelect: () => {},
  onDifficultTopicClick: () => {}
};

export default StudentDashboard;

